import { render, staticRenderFns } from "./RequestBankDecisionBadge.vue?vue&type=template&id=e08d3dbe&scoped=true&"
import script from "./RequestBankDecisionBadge.vue?vue&type=script&lang=js&"
export * from "./RequestBankDecisionBadge.vue?vue&type=script&lang=js&"
import style0 from "./RequestBankDecisionBadge.vue?vue&type=style&index=0&id=e08d3dbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08d3dbe",
  null
  
)

component.options.__file = "RequestBankDecisionBadge.vue"
export default component.exports